<template>
  <div class="pb-5">
    <Navbar/>
    <div class="container">
      <h3 v-if="!existingProductId">Novo pacote</h3>
      <h3 v-if="existingProductId">Editar pacote</h3>

      <form @submit.prevent="addPack">
        <div class="custom-control custom-switch mb-2">
          <input v-model="active" type="checkbox" class="custom-control-input" id="customSwitch1">
          <label class="custom-control-label" for="customSwitch1">Ativo</label>
        </div>
        <div class="form-row">
          <div class="form-group col-md-2">
            <img
              src="../assets/img/open_box.png"
              class="img-fluid img-thumbnail rounded"
              ref="iconPreview"
              @click="$refs.iconInput.click()">
          </div>
          <div class="form-group col-md-10">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label for="inputLang">Idioma</label>
                <select class="form-control" id="inputLang" v-model="lang" :disabled="formLoading" required>
                  <option value="pt-br" selected>Português</option>
                  <option value="en-us">Inglês</option>
                  <option value="es">Espanhol</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-3">
                <label for="inputTitle">Título</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputTitle"
                  v-model="title"
                  :disabled="formLoading"
                  required>
              </div>
              <div class="form-group col">
                <label for="inputDescription">Descrição</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputDescription"
                  v-model="description"
                  :disabled="formLoading"
                  required>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="inputPreviewText">Prévia das palavras</label>
            <input
              type="text"
              class="form-control"
              id="inputPreviewText"
              aria-describedby="helpTextInputPreviewText"
              v-model="previewText"
              :disabled="formLoading">
            <small id="helpTextInputPreviewText">
              Insira palavras separadas por "," (virgula).
              Elas serão apresentadas como prévia do pacote.
              <br>
              Caso este campo não seja preenchido, palavras aleatórias do CSV serão selecionadas.
            </small>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="inputFileWords" v-if="existingWords">Palavras ({{ existingWords.words.length }})</label>
            <label for="inputFileWords" v-else>Palavras</label>
            <button
              type="button"
              class="btn"
              @click="showExistingWordsTable = !showExistingWordsTable"
              v-if="existingWords"
            >
              <i :class="!showExistingWordsTable ?  'fa fa-plus' : 'fa fa-minus'"></i>
            </button>
            <br>
            <template v-if="!existingProductId">
              <input
                type="file"
                class="form-control-file"
                id="inputFileWords"
                @change="parseWordsCSV"
                :disabled="formLoading"
                required>
              <small>Arquivo .csv no formato <b>palavra,pontuação</b></small>
            </template>
            <template v-else>
              <div class="spinner-border text-primary" role="status" v-if="!existingWords">
                <span class="sr-only">Loading...</span>
              </div>

              <transition name="fade">
                <table class="table table-hover table-sm" v-if="showExistingWordsTable">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Palavra</th>
                      <th scope="col">Pontuação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(word, index) in existingWords.words" v-bind:key="word.text">
                      <td scope="row">{{ index + 1 }}</td>
                      <td>{{ word.text.trim().toUpperCase() }}</td>
                      <td>{{ word.score }}</td>
                    </tr>
                  </tbody>
                </table>
              </transition>

              <div
                class="see-pack-words-link text-primary"
                @click="showExistingWordsTable = !showExistingWordsTable"
              >
                <span v-if="!showExistingWordsTable">
                  Mostrar palavras do pacote
                </span>
                <span v-else>
                  Ocultar palavras do pacote
                </span>
              </div>
            </template>
          </div>
          <div class="form-group col d-none">
            <label for="inputFileIcon">Ícone do pacote</label>
            <input
              type="file"
              class="form-control-file"
              id="inputFileIcon"
              @change="handleIcon"
              :disabled="formLoading"
              ref="iconInput">
            <small>Arquivo <b>PNG</b> nas dimensões <b>512x512</b></small>
          </div>
        </div>
        <div class="form-row">
        </div>
        <hr>
        <h4>Informações da Play Store</h4>
        <div class="form-row">
          <div class="form-group col-md-9">
            <label for="inputProductId">ID do produto</label>
            <input
              type="text"
              class="form-control"
              placeholder="Ex.: mimicando.products.packs.movies"
              id="inputProductId"
              aria-describedby="helpTextinputProductId"
              v-model="productId"
              :disabled="formLoading"
              required>
            <small id="helpTextinputProductId">
              Este ID deve ser idêntico ao registrado no produto criado na Play Store,
              caso contrário, o usuário não conseguirá comprar o pacote.
            </small>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="inputOriginalPrice">Preço original (deve ser maior que o preço atual ou igual a 0)</label>
              <money
                v-model="originalPrice"
                v-bind="money"
                class="form-control"
                id="inputOriginalPrice"
                aria-describedby="helpTextinputOriginalPrice"
                :disabled="formLoading"
                required
              >
              </money>
              <small class="text-muted">Deixe em zero quando não há desconto</small>
          </div>
          <div class="form-group col">
            <label for="inputPrice">
              {{ originalPrice > 0 ? 'Preço promocional' : 'Preço' }}
            </label>
            <money
              v-model="price"
              v-bind="money"
              class="form-control"
              id="inputPrice"
              aria-describedby="helpTextinputPrice"
              :disabled="formLoading"
              required
            >
            </money>
            <small v-if="originalPrice > 0" class="text-info">
              Este é o preço com desconto, deve ser menor que o preço original.
            </small>
          </div>
        </div>
        <hr>
        <h4>Informações adicionais</h4>
        <div>
          <small class="text-muted">Desabilitado indefinidamente.</small>
        </div>
        <div v-show="false" class="form-row">
          <div class="form-group col">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                value="isNewPack"
                id="inputIsNewPack"
                v-model="isNewPack"
                :disabled="formLoading">
              <label class="custom-control-label" for="inputIsNewPack">
                Pacote novo <small>(Ex.: Exibe um <i>label</i> de pacote novo dentro do app)</small>
              </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                value="isFeature"
                id="inputIsFeature"
                v-model="isFeature"
                :disabled="formLoading">
              <label class="custom-control-label" for="inputIsFeature">
                É um recurso <small>(Ex.: Recurso desenho)</small>
              </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                value="isOffer"
                id="inputIsOffer"
                v-model="isOffer"
                :disabled="formLoading">
              <label class="custom-control-label" for="inputIsOffer">
                É promoção <small>(Aparecerá na aba "Promoções" ao invés de "Pacotes")</small>
              </label>
            </div>
          </div>
        </div>

        <hr>

        <button
          v-if="!existingProductId"
          type="submit"
          class="btn btn-success btn-lg btn-submit-form"
          :disabled="(!existingProductId && !words) || !this.icon || formLoading">
            <span
              class="spinner-grow spinner-grow-lg"
              role="status"
              aria-hidden="true"
              v-if="formLoading">
            </span>
            <span v-if="!formLoading && !existingProductId">Salvar pacote</span>
            <span v-if="!formLoading && existingProductId">Atualizar pacote</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { db } from '../main'
import { packsRef } from '../main'
import Swal from 'sweetalert2'
import Navbar from '../components/Navbar'
import { Money } from 'v-money'

export default {
  name: 'AddPackage',
  components: {
    Navbar,
    Money
  },
  data() {
    return {
      formLoading: false,
      active: false,
      lang: 'pt-br',
      title: '',
      description: '',
      previewText: '',
      productId: '',
      originalPrice: 0,
      price: 0,
      isNewPack: false,
      isFeature: false,
      isOffer: false,
      words: null,
      icon: null,
      iconPathRef: null,
      existingProductId: this.$route.params.id,
      existingWords: null,
      showExistingWordsTable: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        // suffix: ' #',
        precision: 2,
        masked: false
      }
    }
  },
  created() {
    this.getExistingPack()
  },
  methods: {
    addPack() {
      this.formLoading = true

      // ===========================
      // Pack setup
      // ===========================
      const pack = {
        title: {},
        description: {},
        previewText: {},
        originalPrice: null,
        price: null,
        productId: null,
        img: null,
        numberOfWords: null,
        info: {},
        active: this.active
      }
      pack['title'][this.lang] = this.title
      pack['description'][this.lang] = this.description
      pack['originalPrice'] = parseFloat(this.originalPrice)
      pack['price'] = parseFloat(this.price)
      pack['productId'] = this.productId
      pack['img'] = null
      pack['numberOfWords'] = parseInt(this.words.length)
      pack['info']['isFeature'] = this.isFeature
      pack['info']['isNewPack'] = this.isNewPack
      pack['info']['isOffer'] = this.isOffer
      pack['order'] = 0

      // ===========================
      // Pack words preview (4 words)
      // ===========================
      let wordsForPreviewText = []
      if (!this.existingProductId) {
        if (this.previewText) {
          wordsForPreviewText = this.previewText.split(',')
        } else {
          while (wordsForPreviewText.length < 4) {
            const randomWord = this.words[Math.floor(Math.random() * this.words.length)].text
            const arrayContainsRandomWord = wordsForPreviewText.indexOf(randomWord) > -1
            if (!arrayContainsRandomWord) wordsForPreviewText.push(randomWord)
          }
        }
        pack['previewText'][this.lang] = wordsForPreviewText
      } else {
        pack['previewText'][this.lang] = this.previewText
      }

      // ===========================
      // Icon upload
      // ===========================
      this.iconPathRef = packsRef.child(pack['productId']).child('cover.png')
      this.uploadIcon().then(result => {
        console.log('Imagem enviada com sucesso => ' + result)
      }).catch(err => {
        Swal.fire({
          title: 'Vish...',
          text: 'Erro ao enviar a imagem do pacote, o pacote não foi criado.',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })

      // ===========================
      // Words setup
      // ===========================
      const words = {
        lang: this.lang,
        productId: this.productId,
        words: this.words
      }

      // ===========================
      // Promises
      // ===========================
      const promises = []
      promises.push(
        db.collection('playStoreProducts')
          .doc(pack.productId)
          .set(pack)
      )

      if (!this.existingProductId) {
        promises.push(
          db.collection('words')
            .doc()
            .set(words)
        )
      }

      Promise.all(promises)
        .then(() => {
          this.formLoading = false
          Swal.fire({
            icon: 'success',
            title: 'Tudo certo!',
            text: 'O pacote já está disponível no app!',
            allowOutsideClick: false
          }).then(result => {
            this.$router.push('/dashboard')
          })
        })
        .catch((error) => {
          console.error("Error writing document: ", error)
          this.formLoading = false
          Swal.fire({
            title: 'Error!',
            text: 'Não foi possível salvar o pacote',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
    },
    parseWordsCSV(event) {
      const file = event.target.files[0]
      const csv = this.$papa.parse(file, {
        delimiter: ',',
        complete: (results, file) => {
          this.words = results.data
          this.words = this.words.map((obj, index) => {
            return {
              text: obj[0],
              score: parseInt(obj[1])
            }
          })
          console.log("Parsing complete:", results, file)
        }
      })
    },
    getPreviewText() {
      if (this.previewText) {
        return this.previewText.split(',')
      }
    },
    getExistingPack() {
      if (this.existingProductId) {
        this.formLoading = true

        db.collection('playStoreProducts')
          .doc(this.existingProductId)
          .get()
          .then(doc => {
            const pack = doc.data()
            this.title = pack.title['pt-br']
            this.description = pack.description['pt-br']
            this.previewText = pack.previewText['pt-br'].join(',')
            this.productId = pack.productId
            this.originalPrice = pack.originalPrice
            this.price = pack.price
            this.isNewPack = pack.info.isNewPack
            this.isFeature = pack.info.isFeature
            this.isOffer = pack.info.isOffer
            this.formLoading = false

            db.collection('words')
              .where('productId', '==', this.productId)
              .get()
              .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                  console.log(doc.id, " => ", doc.data())
                  this.existingWords = doc.data()
                })
              })
          })
      }
    },
    handleIcon(event) {
      this.icon = event.target.files[0]

      const reader = new FileReader()
      reader.onload = (event) => {
        this.$refs.iconPreview.src = event.target.result
      }
      reader.readAsDataURL(this.icon)
    },
    uploadIcon() {
      return new Promise((resolve, reject) => {
        resolve(this.iconPathRef.put(this.icon))
      })
    }
  }
}
</script>

<style scoped>
.container {
  margin-top: 16px;
}

button .btn-submit-form {
  margin-top: 8px;
  margin-bottom: 64px;
}

.see-pack-words-link {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
